<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';
import MyLoadsMobileConnectEldBannerComponent from '@/components/myLoads/MyLoadsMobileConnectEldBannerComponent.vue';
import MyLoadsMobileComingSoonBannerComponent from '@/components/myLoads/MyLoadsMobileComingSoonBannerComponent.vue';
import { useScreenSize } from '@/composables/useScreenSize';

const { screenSize } = useScreenSize();
const isDesktop = computed(() => screenSize.value === 'desktop');
const isMobile = computed(() => screenSize.value === 'mobile');
const store = useStore();
const user = computed(() => store.state.users?.currentUser);

const defaultWelcomeMessage = `Let's move some freight.`;
</script>

<template>
  <div
    class="header-texture flex h-[200px] w-full items-center justify-center gap-10 bg-dark-gray px-10 text-steel-900"
  >
    <div
      v-if="isDesktop"
      class="flex max-w-[500px] flex-1 flex-col items-start gap-1"
    >
      <div
        class="w-full max-w-[500px] text-3xl font-medium capitalize leading-[48px] tracking-tight text-steel-0"
      >
        {{
          `Welcome${user.first_name ? `, ${user.first_name.toLowerCase()}` : ''}!`
        }}
      </div>
      <div
        class="w-full max-w-[500px] text-center text-base font-normal leading-7 text-steel-0"
      >
        {{ defaultWelcomeMessage }}
      </div>
    </div>
    <MyLoadsMobileConnectEldBannerComponent
      :container-class="`${isMobile ? 'w-full' : 'w-[315px] mt-10'} h-[140px]`"
    />
    <MyLoadsMobileComingSoonBannerComponent
      :container-class="`${isMobile ? 'w-full' : 'w-[315px] mt-10'} h-[140px]`"
    />
  </div>
</template>

<style scoped>
.welcome-banner {
  background-image: url('/src/assets/header-texture.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
